module.exports = __webpack_public_path__ + "fonts/TheMix_cls_TT5_.b4ad9628.woff";